module.exports = __webpack_public_path__ + "img/noimg.55d1b9f1.png";